<template>
    <div class="wrapper">
        <el-dropdown>
            <div style="display:flex;align-items: center">
                <img src="@/assets/icons/listen.png" alt />
                <p class="font_header service">专属客服</p>
                <p class="server_name">{{server_name}}</p>
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <i class="el-icon-user"></i>
                    {{server_name!='null'?server_name:""}}
                </el-dropdown-item>
                <el-dropdown-item>
                    <i class="el-icon-phone-outline"></i>
                    {{server_phone!='null'?server_phone:""}}
                </el-dropdown-item>
                <el-dropdown-item>
                    <i class="el-icon-mobile-phone"></i>
                    {{server_mobilephone!='null'?server_mobilephone:""}}
                </el-dropdown-item>
                <el-dropdown-item>
                    <i class="el-icon-message"></i>
                    {{server_email!='null'?server_email:""}}
                </el-dropdown-item>
                <el-dropdown-item>
                    <a @click.prevent="openCustomerService">点我咨询</a>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    import { trackEvent, EVENT_CODE } from "@/js/analytics";

    export default {
        components: {},
        props: {},
        data() {
            return {
            };
        },
        watch: {},
        computed: {
            server_name() {
                return this.$store.state.server_name;
            },
            server_phone() {
                return this.$store.state.server_phone;
            },
            server_mobilephone() {
                return this.$store.state.server_mobilephone;
            },
            server_email() {
                return this.$store.state.server_email;
            }
        },
        methods: {
            openCustomerService() {
                trackEvent(EVENT_CODE.PAGE_OPEN_SERVICE_WINDOW, {
                    path: this.$route.path,
                    name: this.$route.name,
                    source: 'header_customer_service',
                    timestamp: Date.now()
                });
                if (window.ECHAT && window.ECHAT.customMiniChat) {
                    window.ECHAT.customMiniChat({ echatTag: 'guanwang' }, { right: '10' });
                    return;
                }
                alert('在线客服功能正在维护中，请稍后再试');
            },
            getdata() {
            }
        },
        created() { },
        mounted() {
            var _echatServer = ['e.echatsoft.com']; //一洽在线客服系统接入
            _echatServer;
            window._echat = function () { (window._echat.q = window._echat.q || []).push(arguments) }; window._echat.l = +new Date;
            window._echat('initParam', { companyId: 521151, echatTag: 'guanwang' });
            (function () {
                var echat = document.createElement('script');
                echat.type = 'text/javascript';
                echat.async = true;
                echat.id = 'echatmodulejs';
                echat.setAttribute('charset', 'UTF-8');
                echat.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.echatsoft.com/visitor/echat.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(echat, s);
            })();
        }
    };
</script>

<style lang="scss" scoped>
    .wrapper {
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-right: 9px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    img {
        width: 20px;
        height: 17px;
        flex-shrink: 0;
    }
    .service {
        padding: 0 6px;
        flex-shrink: 0;
    }
    .server_name {
        font-size: 16px;
        color: #FFCA00;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 1;
        min-width: 0;
    }
    
    @media screen and (max-width: 768px) {
        .server_name {
            display: none;
        }
    }
</style>